import styled from 'styled-components';
import { LANDING_PAGE_WIDTH } from 'developer-docs-shared-components/utils/mediaQueries';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "Section__StyledWrapper",
  componentId: "i7clg2-0"
})(["", " ", " width:100%;display:flex;justify-content:center;padding:64px 0;"], ({
  background
}) => background && `background-color: ${background};`, ({
  backgroundImage
}) => backgroundImage && `
  background-image: url('${backgroundImage}');
  background-repeat: repeat-y;
  background-size: 900px;
  background-position: right;
  ${mediaQueries.belowTablet} {
    background-image: none;
  }
  `);
const ContentWrapper = styled.div.withConfig({
  displayName: "Section__ContentWrapper",
  componentId: "i7clg2-1"
})(["width:", "px;margin:0 30px;"], LANDING_PAGE_WIDTH);
const Section = ({
  children,
  background,
  backgroundImage
}) => {
  return /*#__PURE__*/_jsx(StyledWrapper, {
    background: background,
    backgroundImage: backgroundImage,
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      children: children
    })
  });
};
export default Section;